export const pattern = {
    email: /^(?=.{1,255}$)(?=.{1,64}@)[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+(\.[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+)*@[A-Za-z0-9]([A-Za-z0-9-]{0,63}[A-Za-z0-9])?(\.[A-Za-z0-9]([A-Za-z0-9-]{0,255}[A-Za-z0-9])?)+$/,
    name: /^[a-zA-Z][a-zA-Záéíóúüñ¿¡ .'-]*$/,
    text: /^[a-z A-Z0-9!@#$&;:^*()\-`._+áéíóúüñ¿¡,/\"]*$/,
    password:
        /^(?=.*[a-zA-Z])(?=.*\d)[a-zA-Z0-9\t\n ./<>?;:"'`!@#$%^&*()\[\]{}_+=|\\~,-]{8,50}$/,
};
